import {
  ClusterClusterMetrics,
  ClusterDataUrl,
  OrgOrganization,
  ClusterCluster
} from '@clinic/client'

// spec: https://pingcap.feishu.cn/wiki/wikcnt3dkiFzkcNLxiRNlE2zNHd

export const clusterComponentNameMap = {
  tidb: 'TiDB',
  tikv: 'TiKV',
  pd: 'PD',
  tiflash: 'TiFlash'
} as const

export type ComponentTypes = keyof typeof clusterComponentNameMap

export const grafanaDashboardNameMap: Record<ComponentTypes, string> = {
  tidb: 'TiDB-Cluster-Clinic',
  tikv: 'TiKV-Details-Cluster-Clinic',
  pd: 'PD-Cluster-Clinic',
  tiflash: 'TiFlash-Summary-Cluster-Clinic'
}

export type MetricItemBase = {
  title: string
  subtitle?: string
  desc?: string
  value?: string
  suffix: string
  warning?: boolean
  link: string
  visible?: boolean
}

export type MetricItemExtend = {
  base: MetricItemBase
  converter: (
    base: MetricItemBase,
    clusterMetrics?: ClusterClusterMetrics,
    grafanaDashboards?: ClusterDataUrl[],
    isInternalUser?: boolean,
    org?: OrgOrganization,
    cluster?: ClusterCluster
  ) => MetricItemBase
}

export function getGrafanaDashboardLink(
  component: ComponentTypes,
  grafanaDashboards?: ClusterDataUrl[]
): string {
  const grafanaDashboardName = grafanaDashboardNameMap[component]
  return (
    (grafanaDashboards ?? []).find((d) => d.name === grafanaDashboardName)
      ?.url ?? ''
  )
}
